/**
 * Ensures errorObj is always an array before processing
 * @param {Object|Array} errorObj - The error object or array to process
 * @returns {Array} - Normalized error array
 */
export function normalizeErrorArray(errorObj) {
  if (Array.isArray(errorObj)) {
    return errorObj;
  }
  if (errorObj) {
    return [errorObj];
  }
  return [];
}

/**
 * Extracts error details from error array
 * @param {Array} errorArray - Array of error objects
 * @returns {Object} - Object containing codes, labels, and messages arrays
 */
export function extractErrorDetails(errorArray) {
  if (!errorArray || !Array.isArray(errorArray)) {
    return {
      codes: [],
      labels: [],
      messages: [],
    };
  }

  const codeList = errorArray.map((e) => e?.errorCode) || [];
  const labelList = errorArray.map((e) => e?.developerMessage || e?.message) || [];
  const messageList = errorArray.map((e) => e?.message) || [];

  return {
    codes: codeList,
    labels: labelList,
    messages: messageList,
  };
}

/**
 * Processes error object and returns normalized error details
 * @param {Object|Array} errorObj - The error object or array to process
 * @returns {Object} - Object containing codes, labels, and messages arrays
 */
export function processErrorDetails(errorObj) {
  const errorArray = normalizeErrorArray(errorObj);
  return extractErrorDetails(errorArray);
}
